export type Ts2PyConfig = {
  nullableOptionals?: boolean;
};
